var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzurGamesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 42",
    style: {
      enableBackground: "new 0 0 125 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1B51E8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.6,22.5l-4.7,6.6l-4.7-6.6h-4.5v18.8h5v-10l2.8,3.9h2.8l2.8-3.9v10h4.9V22.5H50.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.1,26.5v-4H57.4v18.8h11.8v-4.1h-6.8v-3.5h6v-4.1h-6v-3.2H69.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,0v5h7.6l-7.6,13v0.8h15.4v-4.9h-7.4l7.4-12.7V0H33.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,0c0,0,0,9.1,0,11.7c0,2.7,2.2,7.1,7.5,7.1s7.5-4.5,7.5-7.1c0-2.7,0-11.7,0-11.7h-5c0,0,0,11.3,0,11.7 s-0.5,2.2-2.5,2.2c-2,0-2.5-1.8-2.5-2.2s0-11.7,0-11.7H50.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,31.2v3.3h3.6c-0.8,1.1-2.2,1.9-3.6,1.9c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5c1.7,0,3.1,0.9,3.9,2.2l4.3-2.5 c-1.6-2.8-4.7-4.7-8.2-4.7C4.2,22.4,0,26.6,0,31.8c0,5.2,4.3,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4c0-0.3,0-0.7,0-0.7H9.4V31.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.4,28.2h5c0,0,0.5-6.2-7-6.2c-7,0-6.8,5.8-6.8,5.8c0,3.9,2.6,4.8,4.3,5.5c1.7,0.7,4.9,0.7,4.9,2.4 s-2,1.7-2,1.7c-2.2,0-2.2-1.9-2.2-1.9h-5.2c0,4.9,4,6.6,7,6.6c3.9,0,7.7-1.6,7.7-6.2c0-3.9-2.8-5.2-4.7-5.7c-3-0.8-4.5-1-4.5-2.4 c0-0.9,0.9-1.2,1.8-1.2C78.6,26.4,79.4,27.2,79.4,28.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,0l-11,18.8h5.3l1.4-2.4H26v2.4h5V0H23.9z M26,12.2H22L26,5.6V12.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,22.5L16.4,41.3h5.3l1.4-2.4h6.3v2.4h5V22.5H27.2z M29.4,34.8h-3.9l3.9-6.6V34.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.8,11.9c0,0,3-1.6,3-5.3C82.8,2.9,80,0,76.1,0c-3.8,0-8.5,0-8.5,0v18.8h5.2V13h1.9l3.1,5.8h5.7L79.8,11.9z  M75.1,8.7h-2.3V4.6h2.2c0,0,2.6-0.1,2.6,2C77.5,8.8,75.1,8.7,75.1,8.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.1,25.4l7.9-4.7L90.1,0v41.3l24.7-14.4l-8.1-4.7l-8.2,4.7V14.4L117.1,25.4z M117,18.3 c1.1,0,1.9,0.9,1.9,1.9c0,1.1-0.9,1.9-1.9,1.9c-1,0-1.9-0.9-1.9-1.9C115.1,19.2,115.9,18.3,117,18.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzurGamesLogo);
export default __webpack_public_path__ + "static/media/Azur Games_logo.5d0ab89e90520f6d3c06c9be9d062b0e.svg";
export { ForwardRef as ReactComponent };